module.exports = __webpack_public_path__ + "img/spring-logo.3b716a9b.png";